export default __webpack_public_path__ + "static/86322-271d37308c084d0b833648eae11f6b06.jpg";